export default "__VITE_ASSET__hkkivVk7__"